import { t } from "@lingui/core/macro"
import Sticky from "react-stickynode"
import "./AgeGateFixedHeader.scss"
import { useAppContext, usePerformToggle } from "../../../hooks/appContext"
import { Button, ButtonSize } from "../../common"
import { InfoOutline, LockAgHeader } from "../../common/atoms/Icons/Others"

interface AgeGateTexts {
    mainText: string
    subText: string
    infoTitle: string
    verifyButton: string
}

interface AgeGateFixedHeaderProps {
    onVerifyClick?: () => void
}

export function AgeGateFixedHeader({
    onVerifyClick = () => {},
}: AgeGateFixedHeaderProps) {
    const isToggleActive: boolean = usePerformToggle("AG_Tease")?.active
    const isAgeGated: boolean = useAppContext().context.user_age_gated
    const showComponent = isToggleActive && isAgeGated

    const texts: AgeGateTexts = {
        mainText: t`Verify Your Age to unlock 18+ content`,
        subText: t`Required by state law. It's fast and we don't store personal data.`,
        infoTitle: t`This is the information about the age gate`,
        verifyButton: t`VERIFY AGE`,
    }

    const stickyHeader = (
        <Sticky innerClass="agegate-sticky-header">
            <div className="age-verification-header">
                <div className="header-content">
                    <div className="lock-icon-container">
                        <LockAgHeader />
                    </div>
                    <div className="text-content">
                        <div className="main-text">{texts.mainText}</div>
                        <div className="sub-text">
                            {texts.subText}
                            <div className="info-icon">
                                <InfoOutline>
                                    <div>PLACEHOLDER</div>
                                </InfoOutline>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="verify-button-container">
                    <Button
                        size={ButtonSize.Large}
                        onClick={onVerifyClick}
                        text={texts.verifyButton}
                        className="verify-button"
                    />
                </div>
            </div>
        </Sticky>
    )

    return showComponent ? stickyHeader : null
}
